import React, { useState } from "react";
import { ButtonSpan } from "../../Button";
import classnames from "classnames";

export default function AccommodationFilter({ accomFilter, setAccomFilter }) {
  return (
    <>
      <div className="mb-2 xxl:mb-0">
        <label className="block uppercase font-heading mb-1 text-xs">
          Accommodation
        </label>
        <div className="flex text-xs min-h-9.5">
          <ButtonSpan
            className={classnames(
              "inline-block flex items-center px-3 border border-grey-md",
              {
                "bg-brand": accomFilter === "",
              }
            )}
            onClick={() => setAccomFilter("")}
          >
            All
          </ButtonSpan>
          <ButtonSpan
            className={classnames(
              "inline-block flex items-center px-3 border border-grey-md border-r-0",
              {
                "bg-brand": accomFilter === "only",
              }
            )}
            onClick={() => setAccomFilter("only")}
          >
            Accom Only
          </ButtonSpan>
          <ButtonSpan
            className={classnames(
              "inline-block flex items-center px-3 border border-grey-md",
              {
                "bg-brand": accomFilter === "exclude",
              }
            )}
            onClick={() => setAccomFilter("exclude")}
          >
            Exclude Accom
          </ButtonSpan>
        </div>
      </div>
    </>
  );
}
